import React from "react";
import { mlbAbValue, mlbPaValue } from "./api/mlbHistoryContext";

export default function MlbHistoryCells({
  entry,
  metricValue,
  showPA = false,
  showAB = false,
  showMetric = false,
  cellStyle,
}) {
  const pa = mlbPaValue(entry);
  const ab = mlbAbValue(entry);
  return (
    <>
      {showPA && <td style={cellStyle}>{Number.isFinite(pa) ? pa : ""}</td>}
      {showAB && <td style={cellStyle}>{Number.isFinite(ab) ? ab : ""}</td>}
      {showMetric && <td style={cellStyle}>{Number.isFinite(metricValue) ? metricValue : "Unavailable"}</td>}
    </>
  );
}
